import React from "react";

const handleLogout = (props) => {
    props.setIsLoggedIn(false);
    localStorage.clear();
}

const Navbar = (props) => {
    return (<div className="fixed top-0 z-50 bg-purple-950 flex py-3 w-full justify-between items-center">
        <span className="text-white font-thin text-xl mx-5 hover:text-fuchsia-600">MotorAutomation</span>
        {props.isLoggedIn && <span className="text-white font-thin text-xl mx-5 hover:text-fuchsia-600" onClick={()=> {handleLogout(props);}}>Logout</span>}

    </div>)
}
export default Navbar;